<template>
  <div class="item-container">
    <img class="item-top-icon" :src="active ? activeIcon : inactiveIcon" />
    <div :class="active ? 'item-bottom-active' : 'item-bottom-inactive'">
      {{ this.text }}
    </div>
  </div>
</template>

<script>
// import { READING_FOOTER_TYPE } from "../../contants/article";
export default {
  name: "FooterItem",
  data() {
    return {};
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    activeIcon: {
      type: String,
      default: null,
    },
    inactiveIcon: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: "",
    },
  },
  methods: {},
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.footer-container {
  position: fixed;
  bottom: 0;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  height: 62px;
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
}

.footer-back {
  width: 50px;
  height: 50px;
}

.footer-content-container {
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.item-container {
  text-align: center;
  margin: auto 10px;
}

.item-top-text {
  &-active {
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
    color: #3994E7;
  }

  &-inactive {
    font-size: 12px;
    line-height: 18px;
    font-weight: bold;
    color: #333333;
  }
}

.item-bottom {
  &-inactive {
    color: #999999;
    margin-top : 4px
    line-height : 16px;
    font-size: 9px;
  }

  &-active {
    color: #3994E7;
    margin-top : 4px
    line-height : 16px;
    font-size: 9px;
  }
}

.item-top-icon {
  margin-top : 4px
  height: 20px;
}

.home-button {
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  margin: 0 20px;
  // width: 100%;
  flex: 1;
  border-radius: 16px;
  background: linear-gradient(right, #98CEFF, #3994E7);
  background-color: orange;
}
</style>


// WEBPACK FOOTER //
// app/components/footer/FooterItem.vue